import { StackView, Select, Spinner, Icon, Text, Menu } from '@planningcenter/tapestry-react';
import React, { useState, useEffect } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import colors from '../../vendor/topbar/colors.js';
import '../../chat_context.js';
import '../../chat_api_context.js';
import { useChatConnectedPeople } from '../../hooks/use_chat_connected_people.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { IndicatorDot } from '../../vendor/topbar/components/indicator_dot.js';

const LinkedAccountSelect = ({ appName, env, currentPersonId, }) => {
    const { people, loading, switchPerson } = useChatConnectedPeople();
    const [connectedPeople, setConnectedPeople] = useState(people);
    const [selected, setSelected] = useState(null);
    const [switching, setSwitching] = useState(false);
    const anyConnectedUnread = connectedPeople === null || connectedPeople === undefined ? undefined : connectedPeople.some((p) => p.id !== `${currentPersonId}` && p.unread_count);
    useEffect(() => {
        if (people) {
            const sortedByOrgName = people.sort((a, b) => a.organization_name.localeCompare(b.organization_name));
            setConnectedPeople(sortedByOrgName);
            const currentPerson = people.find((person) => person.id === `${currentPersonId}`);
            setSelected(currentPerson);
        }
    }, [people]);
    return (React.createElement(StackView, { paddingHorizontal: 2 },
        React.createElement(Select, { emptyValue: "Linked Accounts", disabled: switching, matchWidths: true, onChange: ({ value }) => {
                const person = connectedPeople.find((p) => p.id === value);
                setSelected(person);
                if (person.id !== `${currentPersonId}`) {
                    setSwitching(true);
                    switchPerson(person.id, `${appName}/`, env);
                }
            }, value: selected === null || selected === undefined ? undefined : selected.id, renderValue: () => (React.createElement(StackView, { alignment: "center", axis: "horizontal", distribution: "space-between", spacing: 1 },
                selected.organization_name,
                anyConnectedUnread && !switching && (React.createElement(IndicatorDot, { right: 3.5, top: 1.25 })),
                switching && (React.createElement(Spinner, { key: "loader", position: "absolute", height: 1.5, width: 1.5, zIndex: 6, right: 3.5, top: 1.25 })))) },
            React.createElement(SwitchAccountsWarning, null), connectedPeople === null || connectedPeople === undefined ? undefined :
            connectedPeople.map((connectedPerson) => (React.createElement(Select.Option, { value: connectedPerson.id, key: connectedPerson.id },
                React.createElement(StackView, { alignment: "center", axis: "horizontal", distribution: "space-between", spacing: 1 },
                    connectedPerson.organization_name,
                    connectedPerson.unread_count > 0 && (React.createElement(IndicatorDot, { right: 1.5, top: 1.25 })))))),
            loading && React.createElement(LoadingIndicator, null))));
};
const LoadingIndicator = () => (React.createElement(Menu.Item, { alignment: "center", distribution: "center", paddingBottom: 2, paddingTop: 2 },
    React.createElement(Spinner, null)));
const SwitchAccountsWarning = () => (React.createElement(StackView, { axis: "horizontal", backgroundColor: colors.interaction97, marginBottom: 0.5, marginHorizontal: 1.25, marginTop: 1, padding: 1, radius: 4, spacing: 1 },
    React.createElement(Icon, { color: colors.interaction66, marginTop: "3px", name: "general.outlinedExclamationCircle" }),
    React.createElement(Text, { size: 5 }, "Make sure any changes outside of chat are saved before switching accounts.")));

export { LinkedAccountSelect };
//# sourceMappingURL=linked_account_select.js.map
